import { render, staticRenderFns } from "./setschedule.vue?vue&type=template&id=b8fcabd6&scoped=true&"
import script from "./setschedule.vue?vue&type=script&lang=js&"
export * from "./setschedule.vue?vue&type=script&lang=js&"
import style0 from "./setschedule.vue?vue&type=style&index=0&id=b8fcabd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fcabd6",
  null
  
)

export default component.exports